  <app-customer-profile-grid
    [dataSource]="eliteHistoryDatasource"
    [columnsToDisplay]="columnsToDisplay"
    [titleToDisplay]="titleToDisplay"
    [actions]="actions"
  ></app-customer-profile-grid>

